import { css } from "@emotion/react";

import Menu, {
    centeredAnchorOrigin,
    centeredTransformOrigin
} from "../../../components/DesignComponents/Menu";
import NotificationsContent from "./NotificationsContent";
import { NotificationsDesktopProps } from "./types";

const NotificationsDesktop = ({
    anchorEl,
    close
}: NotificationsDesktopProps) => {
    return (
        <Menu
            open={Boolean(anchorEl)}
            onClose={close}
            anchorEl={anchorEl}
            anchorOrigin={centeredAnchorOrigin}
            transformOrigin={centeredTransformOrigin}
            css={css({
                "& .MuiMenu-paper": {
                    width: "564px"
                }
            })}
        >
            <li>
                <NotificationsContent close={close} />
            </li>
        </Menu>
    );
};

export default NotificationsDesktop;
